import { RootState } from '@/Redux/RootReducer';
import { createSelector } from 'reselect';
import { GenLogisticTypesDataState } from './reducer';

const genLogisticTypesDataSelector = (root: RootState) => root.dynamicData.genLogisticTypesData;

const logisticTypes = createSelector(
  genLogisticTypesDataSelector,
  (state: GenLogisticTypesDataState) => state.logisticTypes,
);

const logisticTypesOptions = createSelector(genLogisticTypesDataSelector, (state: GenLogisticTypesDataState) =>
  state.logisticTypes.map((x) => {
    return { key: x.id, value: x.locName ?? x.name };
  }),
);

export const genLogisticTypesDataSelectors = {
  logisticTypes,
  logisticTypesOptions,
};
